import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import { AuthenticationService } from '../services/authentication.service';

/** 
 * 
 * @author Opeoluwa
 * @dateCreated 25th Aug 2023
 * @description  This interceptor handles HTTP responses with a status code of 401 (Unauthorized).
  When an unauthorized response is detected, it triggers a user logout
 */
@Injectable()
export class RedirectInterceptor implements HttpInterceptor {
	constructor(private authenticationService: AuthenticationService) {}


   /**
   * @author Opeoluwa
   * @dateCreated 25th Aug 2023
   * @param req The outgoing HttpRequest.
   * @param next The HttpHandler for the next interceptor in the chain.
   * @description Intercepts HTTP responses and triggers a logout for unauthorized responses. If the response status is 401 (Unauthorized), the user is logged out.
   * @returns An Observable of the HttpEvent.
   */
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			tap(
				() => {},
				(err) => {
					if (err.status === 401) {
						this.authenticationService.logout();
					}
				}
			)
		);
	}
}